import * as React from 'react';
import {Box, Card, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';

const SubscriptionChoiceItem = ({type, price, unity, required, id}) => {
  const navigate = useNavigate();
  return (
    <Card
      className={'choice-item-card'}
      sx={{
        paddingInline: 1.5,
        paddingTop: 1,
        paddingBottom: 0.5,
        cursor: 'pointer',
      }}
      onClick={() => navigate(`/subscription-detail/${id}`)}
      id={`subscription-${id}`}>
      <Typography variant={'subtitle3'}>Abonnement</Typography>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}>
        <Stack direction={'row'}>
          <Typography
            variant={'subtitle1'}
            sx={{color: '#6D7C84'}}
            id={`subscription-title-${id}`}>
            {type}
          </Typography>
          {required && (
            <Typography variant={'subtitle1'} sx={{color: '#DD809D'}}>
              *
            </Typography>
          )}
        </Stack>

        <Box>
          <Stack
            direction={'row'}
            alignItems={'center'}
            id={`subscription-price-${id}`}>
            <Typography variant={'subtitle1'} sx={{color: '#DD809D'}}>
                {price}€  TTC
            </Typography>
            <Typography variant={'subtitle3'} sx={{color: '#6D7C84'}}>
              /{unity}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Card>
  );
};

export default SubscriptionChoiceItem;
